var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"100%"},attrs:{"id":"app"}},[_c('v-app',{staticStyle:{"height":"100%"}},[_c(_vm.layout,{tag:"component",staticStyle:{"height":"100%"}},[_c('router-view',{key:_vm.authorizationRevision})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }